module.exports = __webpack_public_path__ + "static/media/apartment1.9aeeee81.jpg";